// Full class strings, so Tailwind generates them. The toast must stay above the popup overlay.
export const LAYER_CLASS = {
    POPUP: "z-[999]",
    ABOVE_POPUP: "z-[1000]",
} as const;
